
import { ApiKey } from "@/models/api-key";
import { ApiKeyService } from "@/services/api-key-service";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			keys: [] as ApiKey[],
			newApiKeyName: "",
			newApiKeyModal: false,
			savedApiToken: "",
		};
	},
	watch: {
		newApiKeyModal() {
			this.newApiKeyName = "";
		},
	},
	methods: {
		async deleteKey(key: ApiKey) {
			let message = this.$ct("are-you-sure-you-want-to-delete-api-key", {name: key.name});
			let confirm = await this.$confirmBuilder().setWarningTitle().setMessage(message).show();
			if (!confirm) return;
			await ApiKeyService.deleteApiKey(key.id);
			this.keys = await ApiKeyService.getKeys();
		},
		openNewModal() {
			this.newApiKeyModal = true;
		},
		cancelCreate() {
			this.newApiKeyModal = false;
		},
		async createApiKey() {
			let response = await ApiKeyService.createApiKey(this.newApiKeyName);
			this.savedApiToken = response.token;
			this.newApiKeyModal = false;
			this.keys = await ApiKeyService.getKeys();
		},
		copyLink() {
			(
				(this.$refs.savedKeyInput as any)
					.inputElement as HTMLInputElement
			).select();
			document.execCommand("copy");
			this.$wf.notify(this.$ct("coppied"), "success", 3000, "check");
		},
	},
	async created() {
		this.keys = await ApiKeyService.getKeys();
	},
	i18nEx: {
		componentPrefix: "components.settings-default",
	},
});
